// Herbruikbare, pure slot-berekeningslogica — oorspronkelijk enkel in
// PublicBookingPage.js, hier uitgetrokken zodat ManageBookingPage.js (zelf
// verzetten door de klant) exact dezelfde beschikbaarheidslogica gebruikt in
// plaats van een eigen, mogelijk afwijkende kopie.

// Slots voor één dag, gegeven de vensters en boekingen van die dag.
function timesForDay(dayAvailabilities, dayBookings, serviceObj, minimumNoticeMs) {
    const now = new Date();
    const serviceDuration = serviceObj ? parseInt(serviceObj.duration) : 30;
    const maxParticipants = serviceObj ? parseInt(serviceObj.maxParticipants) : 1;

    // Map op tijdstip i.p.v. een lijst: een losse beschikbaarheid kan
    // overlappen met een venster uit het weekschema (weeklySchedule.js) —
    // hetzelfde slot mag dan maar één keer verschijnen, en in tijdsvolgorde.
    const availableTimes = new Map();

    dayAvailabilities.forEach(av => {
        let start = new Date(av.startTime);
        const end = new Date(av.endTime);

        while (start.getTime() + serviceDuration * 60000 <= end.getTime()) {
            // Vervangt de vroegere "enkel vandaag > nu"-check: een slot telt nu
            // enkel mee als het minstens minimumNoticeHours in de toekomst ligt
            // — geldt voor élke dag, niet enkel vandaag (bv. bij 48u minimum
            // moeten ook de vroege slots van morgen nog uitgesloten worden).
            if (start.getTime() - now.getTime() >= minimumNoticeMs) {

                const startTime = start;
                const endTime = new Date(start.getTime() + serviceDuration * 60000);

                const overlappingBookings = dayBookings.filter(booking => {
                    const bookingStart = new Date(booking.dateTime.seconds * 1000);
                    const bookingEnd = new Date(bookingStart.getTime() + booking.duration * 60000);
                    return (startTime < bookingEnd && endTime > bookingStart);
                });

                if (overlappingBookings.length < maxParticipants) {
                    availableTimes.set(start.getTime(), start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
                }
            }
            start = new Date(start.getTime() + serviceDuration * 60000);
        }
    });

    return [...availableTimes.entries()].sort((a, b) => a[0] - b[0]).map(([, label]) => label);
}

export function calculateAvailableTimes(date, serviceId, { availabilities, services, bookedSlots, minimumNoticeHours = 0 }) {
    if (!date || !serviceId) return [];

    const dayKey = date.toDateString();
    const selectedDateAvailabilities = availabilities.filter(av => av.date.toDateString() === dayKey);
    if (selectedDateAvailabilities.length === 0) {
        return [];
    }

    const bookedSlotsForDate = bookedSlots.filter(booking =>
        new Date(booking.dateTime.seconds * 1000).toDateString() === dayKey
    );

    return timesForDay(selectedDateAvailabilities, bookedSlotsForDate, services.find(s => s.id === serviceId), (minimumNoticeHours || 0) * 3600000);
}

const groupByDay = (items, getDate) => {
    const map = new Map();
    items.forEach(item => {
        const key = getDate(item).toDateString();
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(item);
    });
    return map;
};

export function getAvailableDates(serviceId, { availabilities, services, bookedSlots, minimumNoticeHours = 0 }) {
    if (!serviceId) return [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Vooraf per dag groeperen: met een weekschema zijn er al snel honderden
    // vensters, en per dag opnieuw de volledige lijsten filteren werd kwadratisch.
    const availByDay = groupByDay(availabilities, av => new Date(av.date));
    const bookingsByDay = groupByDay(bookedSlots, b => new Date(b.dateTime.seconds * 1000));
    const serviceObj = services.find(s => s.id === serviceId);
    const minimumNoticeMs = (minimumNoticeHours || 0) * 3600000;

    const dates = [];
    availByDay.forEach((dayAvailabilities, key) => {
        const date = new Date(dayAvailabilities[0].date);
        if (date >= today && timesForDay(dayAvailabilities, bookingsByDay.get(key) || [], serviceObj, minimumNoticeMs).length > 0) {
            dates.push(date);
        }
    });
    return dates;
}

// 32 bytes → 64 hex tekens, cryptografisch willekeurig — gebruikt als
// niet-raadbare "manageToken" voor de zelfbedieningslink in de bevestigingsmail.
export function generateManageToken() {
    const bytes = new Uint8Array(24);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
}
